import styled from 'styled-components'
import React from 'react'
import bgAsset from './logo.svg'

const IntroCardStyled = styled.div`
  border-radius: 14px;
  background: #082822;
  padding: 32px;
  font-family: Unbounded;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);

  h1 {
    margin-top: 16px;
    margin-bottom: 8px;
    font-weight: 700;
    font-size: 20px;
    color: #000;
  }
  p {
    font-weight: 400;
    font-size: 12px;
    margin-top: 0;
    margin-bottom: 0;
    color: #000;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 16px;
    h1 {
      font-size: 16px;
    }
    p {
      font-size: 10px;
    }
`};
`
const BackgroundStyled = styled.div<{ desktopIconIsTransparent?: boolean }>`
  z-index: 0;

  &:before {
    z-index: 2;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-image: url(${bgAsset});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 200px;
    background-position: 96% 50%;
    opacity: ${({ desktopIconIsTransparent }) => (desktopIconIsTransparent ? '0.3' : '0.9')};
    ${({ theme }) => theme.mediaWidth.upToSmall`
      opacity: 0.3;
      background-size: 150px;
  `};
  }
`
const ChildrenStyled = styled.div`
  z-index: 10;
  position: relative;
  h1 {
    color: #4afb39;
  }
  p {
    color: #bec2da;
  }
`

interface IntroCardI {
  children: any
  desktopIconIsTransparent?: boolean
}
const HyperswapIntroCard: React.FC<IntroCardI> = ({ children, desktopIconIsTransparent }) => {
  return (
    <IntroCardStyled>
      <ChildrenStyled>{children}</ChildrenStyled>
      <BackgroundStyled desktopIconIsTransparent={desktopIconIsTransparent} />
    </IntroCardStyled>
  )
}
export default HyperswapIntroCard
